export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9444.1529e265.jpg";